var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocalization = function SvgLocalization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "localization-a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "localization-b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#localization-a)",
    d: "M52.987 34.026c-.072-.021-.155-.026-.443-.026H23.7l4.25 9h20.736l4.69-7.218c.321-.68.113-1.494-.39-1.756zM12.505 34c-2.51.008-4.493-2.075-4.505-4.492-.012-2.435 1.498-4.438 3.958-4.507.038-.001.595-.002 3.374-.001a6.5 6.5 0 0 1 5.877 3.724L23.7 34H12.505zm5.991-3.995A3.5 3.5 0 0 0 15.332 28h-3.29c-.646.018-1.047.55-1.042 1.492.004.801.68 1.51 1.5 1.508h6.466l-.47-.995zM52.5 31c.58 0 .825.014 1.196.108.232.058.457.143.676.257 2.073 1.08 2.723 3.772 1.638 5.856l-.073.125-5.18 7.971A1.5 1.5 0 0 1 49.5 46H27a1.5 1.5 0 0 1-1.356-.86L18.966 31H52.5zm-4 18a1.5 1.5 0 0 1 0 3H30a1.5 1.5 0 0 1-1.342-.83l-3-6a1.5 1.5 0 0 1 2.684-1.34L30.927 49H48.5zM25 40a1.5 1.5 0 0 1 0-3h17.5a1.5 1.5 0 0 1 0 3H25zm6.5 24a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm15 3a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#localization-b)",
    d: "M38 23c5.523 0 10-4.477 10-10S43.523 3 38 3 28 7.477 28 13s4.477 10 10 10zm0 3c-7.18 0-13-5.82-13-13S30.82 0 38 0s13 5.82 13 13-5.82 13-13 13zm0-3c.604 0 1.477-.685 2.308-2.23C41.365 18.808 42 16.02 42 13c0-3.02-.635-5.808-1.692-7.77C39.477 3.685 38.604 3 38 3c-.604 0-1.477.685-2.308 2.23C34.635 7.192 34 9.98 34 13c0 3.02.635 5.808 1.692 7.77C36.523 22.315 37.396 23 38 23zm0 3c-3.866 0-7-5.82-7-13s3.134-13 7-13 7 5.82 7 13-3.134 13-7 13zM26 15v-3h24v3H26z"
  }))));
};
export default SvgLocalization;